<template>
  <footer class="footer-bg">
    <div id="footer-container" class="container" style>
      <div class="row pt-5">
        <!-- <div class="col-12 col-md-5 text-center text-md-left">
          <small style="line-height: 40px;">Demo - P.IVA 0000000</small>
        </div>
        <div class="col-12 col-md-7">
          <ul class="nav d-flex justify-content-between">
            <li class="nav-item text-center">
              <router-link class="nav-link" to="/info/tos" target="_blank"
                >Terms of Service</router-link
              >
            </li>
            <li class="nav-item text-center">
              <router-link class="nav-link" to="/info/privacy" target="_blank"
                >Privacy Policy</router-link
              >
            </li>
          </ul>
        </div>-->
        <div
          class="col-lg-4 col-md-3 col-sm-12 text-lg-left text-center text-md-left text-sm-center mb-lg-0 md-md-0 mb-4"
        >
          <a href="http://fanize.it">
            <img
              class="img-fluid logo-iquii"
              src="/static/tempAssets/logo-gray.svg"
            />
          </a>
        </div>
        <div class="col-lg-3 col-md-2 col-sm-12 my-auto text-center">
          <router-link class="nav-link" to="/info/tos" target="_blank">{{
            $t("Termini di Servizio")
          }}</router-link>
        </div>
        <!-- <div class="col-lg-2 col-md-2 col-sm-12 my-auto text-center">
          Informativa cookie
        </div>-->
        <div class="col-lg-1 col-md-2 col-sm-12 my-auto text-center">
          <router-link class="nav-link" to="/info/privacy" target="_blank">{{
            $t("Privacy")
          }}</router-link>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 my-auto text-center">
          <a
            class="nav-link"
            :href="'mailto:' + $store.state.campaign.support_email"
            target="_blank"
            >{{ $t("Supporto") }}</a
          >
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 my-auto text-center">
          <a href="https://iquii.com/">
            <img
              class="img-fluid logo-iquii"
              src="/static/tempAssets/iquii-logo-white.svg"
            />
          </a>
        </div>
      </div>
      <div class="row pb-2 pt-2">
        <div class="col-12 text-center text-md-left text-lg-left">
          <span class="info-text">
            {{
              $t(
                "Copyright © 2020 Fanize | IQUII. Tutti i diritti riservati. P. IVA:11289201003"
              )
            }}
          </span>
        </div>
      </div>
    </div>
    <!-- <div class="row py-5 mx-0  pt-5"></div> -->
  </footer>
</template>
<script>
import fanizeLogo from "@/assets/svg/rebuild/logo-gray.svg";
import iquiiLogo from "@/assets/svg/rebuild/iquii-logo-white.svg";
export default {
  name: "footer-component",
  data() {
    return {
      fanizeLogo,
      iquiiLogo
    };
  }
};
</script>
<style scoped>
/* @media (min-width: 768px) {
  #footer-container {
    display: block !important;
  }
} */
.info-text {
  font-size: 12px;
}

.footer-bg {
  background-color: #6221e6;
  color: white;
  display: table-row;
  height: 18%;
}
.nav-link {
  color: white !important;
}
@media (max-width: 767.98px) {
  .footer-bg {
    padding-bottom: 5rem;
    width: 100%;
    position: relative;
  }
  .container {
    padding-bottom: 80px;
  }
  .logo-iquii {
    width: 28%;
    margin-top: 10px;
  }
}
@media (min-width: 767px) {
  .logo-iquii {
    width: 60%;
  }
}
</style>
